import { render, staticRenderFns } from "./setMeal.vue?vue&type=template&id=00c82faa&scoped=true&"
import script from "./setMeal.vue?vue&type=script&lang=js&"
export * from "./setMeal.vue?vue&type=script&lang=js&"
import style0 from "./setMeal.vue?vue&type=style&index=0&id=00c82faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c82faa",
  null
  
)

export default component.exports